import { css } from "@linaria/core";

export const accentTheme = css``;

export const buttonWrapper = css`
  margin: auto 0 0 auto;
  padding-inline-end: 15px;
  padding-block-start: 5px;
  padding-block-end: 15px;

  width: fit-content;
`;

export const button = css`
  display: grid;
  place-items: center;
  width: 45px;
  height: 45px;

  border-radius: 50%;
  background: rgba(9 11 25 / 0.1);

  transition: background-color 0.1s linear, color 0.1s linear;

  &.${accentTheme} {
    background: rgb(73 131 0);
    color: rgb(255 255 255);
  }
`;

/* & ${circularSelectors.wrapper()} {
    box-shadow: none !important;
    color: inherit;
  }

  @media ${breakpoints.tablet.toQuery()} {
    & ${circularSelectors.wrapper()} {
      height: 30px !important;
      width: 30px !important;

      & > * {
        height: 12px !important;
      }
    }
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    & ${circularSelectors.wrapper()} {
      height: 36px !important;
      width: 36px !important;

      & > * {
        height: 14px !important;
      }
    }
  }

  @media ${breakpoints.mobile.toQuery()} {
    padding: 0 10px 10px 0;
    align-self: flex-end;
  } */
